import { Alert, Backdrop, Button, CircularProgress, Stack, TextField } from "@mui/material";
import { IApiService } from "../../services/ApiService";
import { useState } from "react";
import { Check } from "@mui/icons-material";
import { LogosHeader } from "../../components/LogosHeader";

export interface ForgotPasswordPageProps {
    readonly api: IApiService;
}

export const ForgotPasswordPage = (props: ForgotPasswordPageProps) => {
    const [email, setEmail] = useState<string | undefined>();
    const [inProgress, setInProgress] = useState<boolean>(false);
    const [done, setDone] = useState(false);
    const [errors, setErrors] = useState<Readonly<{[key: string]: ReadonlyArray<string>}> | undefined>(undefined);
    const [networkError, setNetworkError] = useState<string | undefined>(undefined);
    const formEnabled = email?.trim() && !inProgress;
    const handleClick = async() => {
        if (!formEnabled) {
            return;
        }
        if (!email?.trim()) {
            throw new Error("Unexpected");
        }
        setNetworkError(undefined);
        setErrors(undefined);
        setInProgress(true);
        const controller = new AbortController();
        try {
            var errors = await props.api.sendResetPasswordEmail(email.trim(), controller.signal);
            if (errors) {
                setErrors(errors);
            } else {
                setDone(true);
            }
        } catch (e) {
            setNetworkError("Impossible d'envoyer l'email. Vérifiez votre connexion.");
        } finally {
            setInProgress(false);
        }
    };
    return <Stack sx={{p: 2, pt: 4}} spacing={2}>
        <LogosHeader sx={{mb: 4}} />
        {networkError && <Alert severity="error">{networkError}</Alert>}
        {errors && <Alert severity="error">
            {Object.entries(errors).map(x => x[1].map(error => <>
                {error}<br/>
            </>))}
        </Alert>}
        {!done && !inProgress &&
        <Stack
            component="form"
            spacing={2}>
            <TextField
                onChange={(ev) => setEmail(ev.currentTarget.value)}
                margin="normal"
                required
                fullWidth
                id="email"
                label="Adresse email"
                name="email"
                autoComplete="email"
                autoFocus
            />
            <Button
                onClick={() => handleClick()}
                disabled={!formEnabled}
                type="submit"
                fullWidth
                variant="contained">
                Réinitialiser le mot de passe
            </Button>
        </Stack>}
        <Backdrop open={inProgress}>
            <CircularProgress color="inherit" />
        </Backdrop>
        {done &&
            <Alert icon={<Check fontSize="inherit" />} severity="success">
                Si vous disposez d'un compte, vous recevrez d'ici quelques instants un email pour réinitialiser votre mot de passe.
            </Alert>
        }
    </Stack>
};
